[
  {
    "id": "MET-M7P-L204-001",
    "module": "Metriek",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Reken om: 0,05 m³ = ... liter",
    "options": ["50 liter", "5 liter", "500 liter", "0,5 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "omrekenen_m3_naar_liter",
    "familyId": "MET-INHOUD-M3-NAAR-LITER",
    "conceptId": "convert_m3_to_liters_decimal",
    "variantIndex": 1,
    "explanation": "Onthoud: 1 m³ = 1.000 liter.\nDus 0,05 m³ × 1.000 = 50 liter.\n(Je schuift de komma drie plaatsen: 0,05 → 50.)",
    "distractorExplanations": {
      "1": "Je hebt maar met 100 vermenigvuldigd (alsof het om cm/m gaat). Bij inhoud is m³ → liter een factor 1.000.",
      "2": "Je hebt de komma te ver geschoven (×10.000). Bij m³ naar liter/dm³ is het precies ×1.000.",
      "3": "Je hebt de komma maar één plek verschoven (×10). Dat is lengte-denken; inhoud werkt in stappen van 1.000."
    }
  },
  {
    "id": "MET-M7P-L204-002",
    "module": "Metriek",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Een zwembad is 25 m lang, 10 m breed en 2 m diep. Hoeveel liter water gaat erin?",
    "options": ["500.000 liter", "50.000 liter", "5.000 liter", "500 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud_berekenen_balk_naar_liter",
    "familyId": "MET-INHOUD-BALK-NAAR-LITER",
    "conceptId": "volume_rectangular_prism_to_liters",
    "variantIndex": 1,
    "explanation": "Eerst inhoud in m³: 25 × 10 × 2 = 500 m³.\nDaarna omrekenen: 1 m³ = 1.000 liter.\nDus 500 × 1.000 = 500.000 liter.",
    "distractorExplanations": {
      "1": "Je hebt één nul te weinig: 500 m³ is niet 50.000 liter maar 500.000 liter (×1.000!).",
      "2": "Je hebt twee nullen te weinig of je hebt per ongeluk met 10 gerekend. Bij m³ → liter moet je altijd ×1.000 doen.",
      "3": "Je hebt alleen de inhoud in m³ gevonden (500), maar je moet nog omrekenen naar liters."
    }
  },
  {
    "id": "MET-M7P-L204-003",
    "module": "Metriek",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Reken om: 12.500 mm² = ... dm²",
    "options": ["1,25 dm²", "12,5 dm²", "125 dm²", "0,125 dm²"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "omrekenen_mm2_naar_dm2",
    "familyId": "MET-OPP-MM2-NAAR-DM2",
    "conceptId": "convert_area_mm2_to_dm2",
    "variantIndex": 1,
    "explanation": "Bij oppervlakte is elke stap geen ×10 maar ×100.\nmm² → cm²: ÷100 → 12.500 ÷ 100 = 125 cm².\ncm² → dm²: ÷100 → 125 ÷ 100 = 1,25 dm².",
    "distractorExplanations": {
      "1": "Je bent gestopt na mm² → cm². 125 cm² moet nog naar dm² (nogmaals ÷100).",
      "2": "Je hebt maar één keer door 100 gedeeld in totaal. Maar van mm² naar dm² zijn twee stappen: ÷100 en nog eens ÷100.",
      "3": "Je hebt te veel gedeeld (alsof er nóg een stap bij kwam). Het zijn precies twee stappen: mm² → cm² → dm²."
    }
  },
  {
    "id": "MET-M7P-L204-004",
    "module": "Metriek",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Een L-vormige kamer bestaat uit twee rechthoeken: 4×5 m en 2×3 m. Wat is de totale oppervlakte?",
    "options": ["26 m²", "20 m²", "6 m²", "30 m²"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "samengestelde_figuur_optellen",
    "familyId": "MET-OPP-SAMENGESTELD-OPTELLEN",
    "conceptId": "composite_area_sum_rectangles",
    "variantIndex": 1,
    "explanation": "Splits in twee rechthoeken.\n4×5 = 20 m².\n2×3 = 6 m².\nSamen: 20 + 6 = 26 m².",
    "distractorExplanations": {
      "1": "Dit is alleen het grote stuk (4×5). Bij een samengestelde figuur tel je de delen bij elkaar op.",
      "2": "Dit is alleen het kleine stuk (2×3). Je vergeet het grootste deel van de kamer.",
      "3": "30 krijg je als je de oppervlakten verkeerd optelt of één maat verwisselt. Reken elk blok los uit en tel daarna op."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Samengestelde figuur",
        "content": "Splits in rechthoeken → bereken elk deel → tel de oppervlakten op.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-M7P-L204-005",
    "module": "Metriek",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Hoeveel hectare is 50.000 m²?",
    "options": ["5 ha", "50 ha", "0,5 ha", "500 ha"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "omrekenen_m2_naar_hectare",
    "familyId": "MET-OPP-M2-NAAR-HECTARE",
    "conceptId": "convert_m2_to_hectares",
    "variantIndex": 1,
    "explanation": "1 hectare = 10.000 m².\n50.000 m² ÷ 10.000 = 5 hectare.",
    "distractorExplanations": {
      "1": "Je hebt gedeeld door 1.000. Maar hectare is 10.000 m², dus je moet door 10.000 delen.",
      "2": "Je hebt één nul te veel weggehaald (alsof het 100.000 was). 50.000 is precies 5×10.000.",
      "3": "Je hebt gedeeld door 100 (are-denken). Are is 100 m²; hectare is 10.000 m²."
    }
  },
  {
    "id": "MET-M7P-L204-006",
    "module": "Metriek",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Een driehoek heeft een basis van 14 cm en een hoogte van 9 cm. Wat is de oppervlakte?",
    "options": ["63 cm²", "126 cm²", "23 cm²", "56 cm²"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte_driehoek",
    "familyId": "MET-OPP-DRIEHOEK-BASIS_HOOGTE",
    "conceptId": "triangle_area_base_height",
    "variantIndex": 1,
    "explanation": "Formule driehoek: (basis × hoogte) ÷ 2.\n14 × 9 = 126.\n126 ÷ 2 = 63 cm².",
    "distractorExplanations": {
      "1": "Je bent vergeten te delen door 2. Een driehoek is ‘de helft’ van een rechthoek met dezelfde basis en hoogte.",
      "2": "Je hebt basis en hoogte opgeteld. Voor oppervlakte moet je vermenigvuldigen (en daarna nog ÷2).",
      "3": "56 is alsof je met 8 hebt gerekend of de hoogte verkeerd hebt gelezen. De hoogte is 9 cm."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Driehoek",
        "content": "Oppervlakte = (basis × hoogte) ÷ 2",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-M7P-L204-007",
    "module": "Metriek",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Reken om: 3,5 m² = ... cm²",
    "options": ["35.000 cm²", "3.500 cm²", "350 cm²", "350.000 cm²"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "omrekenen_m2_naar_cm2",
    "familyId": "MET-OPP-M2-NAAR-CM2",
    "conceptId": "convert_area_m2_to_cm2",
    "variantIndex": 1,
    "explanation": "1 m = 100 cm, dus 1 m² = 100×100 = 10.000 cm².\n3,5 m² = 3,5 × 10.000 = 35.000 cm².",
    "distractorExplanations": {
      "1": "Je hebt ×1.000 gedaan. Maar bij m² → cm² is het ×10.000 (twee keer ×100).",
      "2": "Je hebt ×100 gedaan (alsof het lengte is). Oppervlakte heeft twee dimensies: daarom ×10.000.",
      "3": "Je hebt één stap te veel gezet (×100.000). Controleer: 1 m² is 10.000 cm², geen 100.000."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "m² → cm²",
        "content": "Oppervlakte: m² naar cm² = ×10.000 (100×100).",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-M7P-L204-008",
    "module": "Metriek",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Een T-vormig stuk grond bestaat uit twee rechthoeken: 10×3 m en 4×6 m. Wat is de totale oppervlakte?",
    "options": ["54 m²", "30 m²", "24 m²", "60 m²"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "samengestelde_figuur_optellen",
    "familyId": "MET-OPP-SAMENGESTELD-OPTELLEN",
    "conceptId": "composite_area_sum_rectangles",
    "variantIndex": 2,
    "explanation": "Bereken elk rechthoekdeel los.\n10×3 = 30 m².\n4×6 = 24 m².\nSamen: 30 + 24 = 54 m².",
    "distractorExplanations": {
      "1": "Dit is alleen het eerste deel (10×3). Je mist het tweede rechthoekdeel (4×6).",
      "2": "Dit is alleen het tweede deel (4×6). Je mist het lange deel van 10×3.",
      "3": "60 kan ontstaan als je maten door elkaar haalt of per ongeluk 10×6 doet. Houd de twee rechthoeken apart en tel dan op."
    }
  },
  {
    "id": "MET-M7P-L204-009",
    "module": "Metriek",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Een bak is 60 cm lang, 40 cm breed en 30 cm hoog. Hoeveel liter past erin?",
    "options": ["72 liter", "7,2 liter", "720 liter", "130 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud_berekenen_cm3_naar_liter",
    "familyId": "MET-INHOUD-CM3-NAAR-LITER-BALK",
    "conceptId": "volume_cm3_to_liters_rectangular_prism",
    "variantIndex": 1,
    "explanation": "Eerst cm³: 60×40×30 = 72.000 cm³.\nDan omrekenen: 1.000 cm³ = 1 liter.\n72.000 ÷ 1.000 = 72 liter.",
    "distractorExplanations": {
      "1": "Je hebt gedeeld door 10.000. Maar 1 liter is 1.000 cm³, dus je deelt door 1.000.",
      "2": "Je bent vergeten om van cm³ naar liter om te rekenen. 72.000 cm³ klinkt groot, maar in liters is dat 72.",
      "3": "Je hebt waarschijnlijk opgeteld in plaats van vermenigvuldigd. Inhoud van een balk is lengte × breedte × hoogte."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "cm³ → liter",
        "content": "Bereken eerst cm³ (l×b×h). Deel daarna door 1.000 voor liters.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-M7P-L204-010",
    "module": "Metriek",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Een voetbalveld is 1,05 hectare. Hoeveel vierkante meter is dat?",
    "options": ["10.500 m²", "1.050 m²", "105.000 m²", "105 m²"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "omrekenen_hectare_naar_m2",
    "familyId": "MET-OPP-HECTARE-NAAR-M2",
    "conceptId": "convert_hectares_to_m2_decimal",
    "variantIndex": 1,
    "explanation": "1 ha = 10.000 m².\n1,05 ha = 1,05 × 10.000 = 10.500 m².\n(De 0,05 ha is 500 m².)",
    "distractorExplanations": {
      "1": "Je hebt ×1.000 gedaan. Maar hectare naar m² is ×10.000.",
      "2": "Je hebt de komma één plek te ver geschoven (×100.000). Controleer: 1 ha is 10.000 m², dus 1,05 ha kan geen 105.000 m² zijn.",
      "3": "Je hebt ×100 gedaan (are-denken). Are is 100 m², hectare is 10.000 m²."
    }
  },
  {
    "id": "MET-M7P-L204-011",
    "module": "Metriek",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Een rechthoek heeft een oppervlakte van 150 cm². De lengte is 15 cm. Wat is de omtrek?",
    "options": ["50 cm", "25 cm", "30 cm", "60 cm"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek_via_oppervlakte",
    "familyId": "MET-OMTREK-VIA-OPP-RECHTHOEK",
    "conceptId": "perimeter_from_area_and_side",
    "variantIndex": 1,
    "explanation": "Eerst de breedte: oppervlakte ÷ lengte = 150 ÷ 15 = 10 cm.\nOmtrek = 2 × (lengte + breedte) = 2 × (15 + 10) = 2 × 25 = 50 cm.",
    "distractorExplanations": {
      "1": "25 cm is alleen lengte + breedte. Voor omtrek moet je beide lengtes én beide breedtes nemen: dus ×2.",
      "2": "30 cm krijg je als je alleen de lengtes optelt (15+15). Maar de breedtes (10+10) horen er ook bij.",
      "3": "60 cm is alsof je denkt dat alle zijden 15 cm zijn (vierkant-idee) of 15×4. Maar je rechthoek heeft 15 en 10."
    }
  },
  {
    "id": "MET-M7P-L204-012",
    "module": "Metriek",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Reken om: 0,8 m³ = ... dm³",
    "options": ["800 dm³", "80 dm³", "8.000 dm³", "8 dm³"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "omrekenen_m3_naar_dm3",
    "familyId": "MET-INHOUD-M3-NAAR-DM3",
    "conceptId": "convert_m3_to_dm3_decimal",
    "variantIndex": 1,
    "explanation": "Bij inhoud is elke stap ×1.000.\n1 m³ = 1.000 dm³.\nDus 0,8 × 1.000 = 800 dm³.",
    "distractorExplanations": {
      "1": "Je hebt ×100 gedaan (oppervlakte-denken). Inhoud werkt per stap met ×1.000.",
      "2": "Je hebt gedaan alsof het twee stappen zijn (×1.000.000). Maar m³ → dm³ is precies één stap: ×1.000.",
      "3": "Je hebt ×10 gedaan (lengte-denken). Bij m³ gaat het om kubieke eenheden: ×1.000."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Inhoud omrekenen",
        "content": "Kubieke eenheden: elke stap is ×1.000 (m³ → dm³ → cm³).",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-M7P-L204-013",
    "module": "Metriek",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Een tuin van 8 m bij 12 m heeft een pad van 1 m breed eromheen. Wat is de oppervlakte van alleen het pad?",
    "options": ["44 m²", "96 m²", "140 m²", "48 m²"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "pad_rondom_buitenmaat_min_binnenmaat",
    "familyId": "MET-OPP-PAD-RONDOM",
    "conceptId": "border_area_outer_minus_inner",
    "variantIndex": 1,
    "explanation": "Het pad zit aan alle kanten, dus je telt 2 meter bij elke maat op.\nBuitenmaat: (8+2) × (12+2) = 10 × 14 = 140 m².\nBinnen (tuin): 8 × 12 = 96 m².\nPad: 140 − 96 = 44 m².",
    "distractorExplanations": {
      "1": "96 m² is de tuin zelf (zonder pad). Je moest juist het verschil nemen tussen buiten en binnen.",
      "2": "140 m² is tuin + pad samen. Maar de vraag is: alleen het pad, dus je moet de tuin eraf trekken.",
      "3": "48 m² krijg je vaak door alleen 1 meter bij één kant te tellen (of door omtrek-denken). Het pad is rondom: daarom +2 op beide maten."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Pad berekenen",
        "content": "Buitenmaat (tuin+pad) − Binnenmaat (tuin) = Oppervlakte pad.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-M7P-L204-014",
    "module": "Metriek",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Hoeveel are is 2.500 m²?",
    "options": ["25 are", "250 are", "2,5 are", "0,25 are"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "omrekenen_m2_naar_are",
    "familyId": "MET-OPP-M2-NAAR-ARE",
    "conceptId": "convert_m2_to_are",
    "variantIndex": 1,
    "explanation": "1 are = 100 m².\n2.500 m² ÷ 100 = 25 are.",
    "distractorExplanations": {
      "1": "Je hebt gedeeld door 10. Maar are is 100 m², dus je moet door 100 delen.",
      "2": "Je hebt gedeeld door 1.000. Dat maakt het 10× te klein. Deel door 100: dan kom je op 25.",
      "3": "Je hebt gedeeld door 10.000 (hectare-denken). Are is veel kleiner: 100 m²."
    }
  },
  {
    "id": "MET-M7P-L204-015",
    "module": "Metriek",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Een aquarium is 80 cm lang, 35 cm breed en 40 cm hoog. Hoeveel liter past erin?",
    "options": ["112 liter", "11,2 liter", "1.120 liter", "155 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud_berekenen_cm3_naar_liter",
    "familyId": "MET-INHOUD-CM3-NAAR-LITER-BALK",
    "conceptId": "volume_cm3_to_liters_rectangular_prism",
    "variantIndex": 2,
    "explanation": "Eerst cm³: 80×35×40 = 112.000 cm³.\nOmrekenen: 112.000 ÷ 1.000 = 112 liter.",
    "distractorExplanations": {
      "1": "Je hebt te veel gedeeld (door 10.000). Onthoud: 1 liter = 1.000 cm³, dus deel door 1.000.",
      "2": "Je hebt niet omgerekend naar liters. 112.000 cm³ klinkt enorm, maar in liters is dat 112.",
      "3": "155 liter komt vaak door verkeerd vermenigvuldigen of door optellen. Bij inhoud hoort altijd l×b×h."
    }
  }
]
